import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Image } from './styles';
export const ImageShrink = ({ scale, scaleDesktop, scaleMobile, ...rest }) => {
    const myScaleDesktop = scaleDesktop ?? scale ?? 0;
    const myScaleMobile = scaleMobile ?? scale ?? 0;
    const imageRef = React.useRef(null);
    const [widthDesktop, setWidthDesktop] = React.useState(0);
    const [widthMobile, setWidthMobile] = React.useState(0);
    const update = React.useCallback(() => {
        if (!imageRef.current)
            return;
        setWidthDesktop(myScaleDesktop * imageRef.current.naturalWidth);
        setWidthMobile(myScaleMobile * imageRef.current.naturalWidth);
    }, [imageRef, setWidthDesktop, setWidthMobile, myScaleDesktop, myScaleMobile]);
    React.useEffect(() => {
        update();
        if (!window)
            return;
        const events = ['orientationchange', 'resize'];
        events.forEach(e => window.addEventListener(e, update));
        return () => events.forEach(e => window.removeEventListener(e, update));
    });
    return _jsx(Image, { ref: imageRef, onLoad: update, widthMobile, widthDesktop, ...rest });
};
//# sourceMappingURL=ImageShrink.js.map